/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsAttributionApplyInput
 */
export interface GoogleAnalyticsAttributionApplyInput {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionApplyInput
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionApplyInput
     */
    evidenceId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionApplyInput
     */
    googleAdsCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionApplyInput
     */
    googleAdsCampaignId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionApplyInput
     */
    reason?: string;
}

/**
 * Check if a given object implements the GoogleAnalyticsAttributionApplyInput interface.
 */
export function instanceOfGoogleAnalyticsAttributionApplyInput(value: object): value is GoogleAnalyticsAttributionApplyInput {
    return true;
}

export function GoogleAnalyticsAttributionApplyInputFromJSON(json: any): GoogleAnalyticsAttributionApplyInput {
    return GoogleAnalyticsAttributionApplyInputFromJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionApplyInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAttributionApplyInput {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'evidenceId': json['evidenceId'] == null ? undefined : json['evidenceId'],
        'googleAdsCustomerId': json['googleAdsCustomerId'] == null ? undefined : json['googleAdsCustomerId'],
        'googleAdsCampaignId': json['googleAdsCampaignId'] == null ? undefined : json['googleAdsCampaignId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function GoogleAnalyticsAttributionApplyInputToJSON(json: any): GoogleAnalyticsAttributionApplyInput {
    return GoogleAnalyticsAttributionApplyInputToJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionApplyInputToJSONTyped(value?: GoogleAnalyticsAttributionApplyInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'evidenceId': value['evidenceId'],
        'googleAdsCustomerId': value['googleAdsCustomerId'],
        'googleAdsCampaignId': value['googleAdsCampaignId'],
        'reason': value['reason'],
    };
}

